// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"guided_scrollbar__19nzP"};